import React, { useState, useEffect } from 'react';
import ForeFlightLogo from '../../common/ForeFlightLogo';
import { styled } from '@mui/material/styles';
import Cookies from '../../common/cookieManager';
import { useIsEuCustomerQuery } from '../slices/apis/geoLocationApi';

const Banner = styled('div')`
    display: block;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #3498db;
    color: #fff;
    z-index: 99999999;
    padding: 20px;
    box-sizing: border-box;
    line-height: 1.4;
    font-size: 13px;
    -webkit-transition: all ease 0.3s;
    transition: all ease 0.3s;
    opacity: 1;

    .banner-item {
        width: 100%;
        max-width: 1260px;
        margin: auto;
        text-align: left;
        padding: 5px;
        vertical-align: middle;
        overflow: hidden;

        a {
            color: #ffffff !important;
            text-decoration: underline;
        }
        span {
            width: 85%;
            float: left;
            display: inline-block;
            line-height: 1.8;
            font-size: 14px;
            font-family: $font-primary;
            font-weight: 400;

            @media all and (max-width: 768px) {
                width: 100%;
                float: none;
            }
        }
        .banner-logo {
            float: left;
            width: 5%;
            margin-right: 2%;

            img {
                width: 100%;
                max-width: 50px;
                vertical-align: middle;
            }
            @media all and (max-width: 1070px) {
                display: none;
            }
        }
        button {
            color: #ffffff;
            border: 2px solid #ffffff;
            background: transparent;
            display: inline-block;
            border-radius: 4px;
            padding: 10px;
            float: right;
            font-weight: bold;
            -webkit-font-smoothing: antialiased;
            letter-spacing: 0.6px;
            font-family: $font-primary;
            font-size: 1rem;
            transition: all 0.3s ease-in-out;
            -webkit-transition: all 0.3s ease-in-out;
            cursor: pointer;

            &:hover {
                background: #fff;
                color: #008cba;
            }
            @media all and (max-width: 768px) {
                float: left;
                margin-top: 15px;
                margin-bottom: 0;
            }
        }
    }
`;

const EU_COOKIE_BANNER = 'show_eu_cookie_directive';
const EURO_COOKIE_EXPIRATION_DAYS = 30;

const EuCookieBanner = () => {
    const [displayBanner, setDisplayBanner] = useState(false);
    const { data: isEU = false } = useIsEuCustomerQuery();

    useEffect(() => {
        const cookieValue = Cookies.get(EU_COOKIE_BANNER);
        if (isEU && (!cookieValue || cookieValue === '0')) {
            setDisplayBanner(true);
        }
    }, []);

    const handleClose = () => {
        setDisplayBanner(false);
        const domain = window.location.hostname === 'localhost' ? undefined : '.foreflight.com';
        const secure = window.location.hostname !== 'localhost';
        const maxAge = 3600 * 24 * EURO_COOKIE_EXPIRATION_DAYS;

        Cookies.set(EU_COOKIE_BANNER, '1', maxAge, '/', domain, secure);
    };

    if (!displayBanner) {
        return <></>;
    }

    return (
        <Banner>
            <div className="banner-item">
                <div className="banner-logo">
                    <ForeFlightLogo />
                </div>
                <span>
                    We use cookies to store and personalize content, improve our services, and to
                    analyze usage for marketing. We also share information about your use of our
                    site with Google Analytics and Segment. You can find out more about our use of
                    cookies by viewing our{' '}
                    <a href="/about/privacy">
                        <b>Privacy Statement</b>
                    </a>
                    . You can change your browser setting to avoid cookies at any time. By
                    continuing to use the site without changing your settings, you are agreeing to
                    our use of cookies.
                </span>
                <button id="eu-banner-btn" onClick={handleClose}>
                    CLOSE
                </button>
            </div>
        </Banner>
    );
};
export default EuCookieBanner;
